/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Status_ResolvedInputs */

const en_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolved`)
};

const fr_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolue`)
};

const de_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelöst`)
};

const it_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risolto`)
};

const ru_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Решено`)
};

const es_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resuelto`)
};

const zh_cn2_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已解决`)
};

const ja_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解決済み`)
};

const hi_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हल किया`)
};

const pt_pt2_manual_qc_status_resolved = /** @type {(inputs: Manual_Qc_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolvido`)
};

/**
* | output |
* | --- |
* | "Resolved" |
*
* @param {Manual_Qc_Status_ResolvedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_status_resolved = /** @type {((inputs?: Manual_Qc_Status_ResolvedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Status_ResolvedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_status_resolved(inputs)
	if (locale === "de") return de_manual_qc_status_resolved(inputs)
	if (locale === "it") return it_manual_qc_status_resolved(inputs)
	if (locale === "ru") return ru_manual_qc_status_resolved(inputs)
	if (locale === "es") return es_manual_qc_status_resolved(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_status_resolved(inputs)
	if (locale === "ja") return ja_manual_qc_status_resolved(inputs)
	if (locale === "hi") return hi_manual_qc_status_resolved(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_status_resolved(inputs)
	return en_manual_qc_status_resolved(inputs)
});